import { useCallback, useEffect, useState } from "react";

const KEY = "hw_notif_prefs_v1";
const DEFAULTS = { browser: true, task: true, mail: true };

export function getNotifPrefs() {
  try {
    return { ...DEFAULTS, ...JSON.parse(localStorage.getItem(KEY) || "{}") };
  } catch {
    return { ...DEFAULTS };
  }
}

export function setNotifPrefs(patch) {
  const next = { ...getNotifPrefs(), ...patch };
  localStorage.setItem(KEY, JSON.stringify(next));
  window.dispatchEvent(new CustomEvent("hw-notif-prefs", { detail: next }));
  return next;
}

// Apply account-stored prefs to this device (local), without re-saving to server.
export function applyServerNotifPrefs(prefs) {
  if (!prefs || typeof prefs !== "object") return getNotifPrefs();
  const next = {
    browser: prefs.browser !== false,
    task: prefs.task !== false,
    mail: prefs.mail !== false,
  };
  localStorage.setItem(KEY, JSON.stringify(next));
  window.dispatchEvent(new CustomEvent("hw-notif-prefs", { detail: next }));
  return next;
}

// Persist the current prefs to the user's account (valid on all devices).
export function pushNotifPrefsToServer(api, prefs) {
  try {
    return api.put("/me/notif-prefs", prefs || getNotifPrefs());
  } catch {
    return Promise.resolve();
  }
}

export function useNotifPrefs() {
  const [prefs, setPrefs] = useState(getNotifPrefs);
  useEffect(() => {
    const handler = (e) => setPrefs(e.detail || getNotifPrefs());
    window.addEventListener("hw-notif-prefs", handler);
    return () => window.removeEventListener("hw-notif-prefs", handler);
  }, []);
  const toggle = useCallback((key, value) => setPrefs(setNotifPrefs({ [key]: value })), []);
  return { prefs, toggle };
}
